export default class ComparatorService {
    compareByName(a, b) {
        if (a._name !== null || b._name !== null) {
            return a._name.localeCompare(b._name);
        }
    }
    compareByStartTime(a, b) {
        if (a._startBlock !== null || b.startBlock !== null) {
            return a._startBlock - b._startBlock;
        }
    }
}
